export type AdminLoginRedirectReason = "session_expired" | "unauthorized";

type SessionExpiredHandler = () => void;

let handler: SessionExpiredHandler | null = null;
let notified = false;

export function setAdminSessionExpiredHandler(
  next: SessionExpiredHandler | null,
): void {
  handler = next;
  notified = false;
}

/** Called when refresh fails or a retried request is still unauthorized. */
export function notifyAdminSessionExpired(): void {
  if (notified || !handler) return;
  notified = true;
  handler();
}

export function resetAdminSessionExpiredNotified(): void {
  notified = false;
}
